import Vue from 'vue';
import Store from '@app/store';
import Modules from '@app/modules';
import MenuComponent from '@app/modules/RF/CMS/Menu.vue';
import LanguageSwitchComponent from '@app/components/LanguageSwitch.vue';
import SvgLoader from '@app/components/Utilities/SvgLoader.vue';
// @ts-ignore
import { headroom as Headroom } from 'vue-headroom';
export default Vue.extend({
    components: {
        Headroom: Headroom,
        MenuComponent: MenuComponent,
        LanguageSwitchComponent: LanguageSwitchComponent,
        SvgLoader: SvgLoader
    },
    watch: {
        $route: function () {
            Store.Navigation.ACTIONS.close();
        }
    },
    data: function () { return ({
        navModuleComponents: Modules.getTaggedComponents('nav'),
        iconBarModuleComponents: Modules.getTaggedComponents('iconBar')
    }); },
    computed: {
        isNavigationOpen: function () {
            return Store.Navigation.STATE.isOpen;
        },
        navigationItems: function () {
            return Store.Navigation.STATE.items;
        },
        navigationItemsLeft: function () {
            var length = this['navigationItems'].length;
            var half = Math.ceil(length / 2);
            var array = this['navigationItems'].slice(0, half);
            return array;
        },
        navigationItemsRight: function () {
            var length = this['navigationItems'].length;
            var half = Math.ceil(length / 2);
            var array = this['navigationItems'].slice(half, length);
            return array;
        },
        languages: function () {
            return Store.STATE.languages;
        }
    },
    methods: {
        toggleNavigation: function () {
            Store.Navigation.ACTIONS.toggle();
        },
        closeNavigation: function () {
            Store.Navigation.ACTIONS.close();
        },
        openNavigation: function () {
            Store.Navigation.ACTIONS.open();
        }
    }
});
